module.exports = __webpack_public_path__ + "690595a9545b02e0ab9b5555b24d4180.svg";